module.exports = __webpack_public_path__ + "static/media/img-11.d72f1f40.jpg";